'use client';
import React from "react";
import "./RelatedArticlesCard.css";
import { Placeholder } from "react-bootstrap";
import Image from "next/image";

const RelatedArticlesCard = ({ posts, loading, onArticleClick }) => {
  if (!posts || posts.length === 0) return null;

  if (loading) {
    return (
      <div className="blogs-card">
        <Placeholder as="div" animation="glow">
          <div
            className="blogs-image placeholder-img bg-secondary"
            style={{ height: "180px" }}
          />
        </Placeholder>
        <div className="blogs-content">
          <Placeholder as="p" animation="glow">
            <Placeholder xs={4} /> <Placeholder xs={6} />
          </Placeholder>
          <Placeholder as="h2" animation="glow">
            <Placeholder xs={8} />
          </Placeholder>
          <Placeholder as="p" animation="glow">
            <Placeholder xs={10} /> <Placeholder xs={5} />
          </Placeholder>
        </div>
      </div>
    );
  }

  return (
    <div className="related-articles">
      <h4>Related Articles</h4>
      {posts.map((article) => (
        <button
          key={article.id}
          type="button"
          className="related-article-item-button"
          onClick={() => onArticleClick?.(article.categoryslug, article.slug)}
        >
          <div className="related-article-item">
            <Image
              src={article.image || "/images/ImgPlaceholder.svg"}
              alt={article.title}
              width={120}
              height={80}
              className="related-article-img"
            />
            <div className="related-article-text">
              <p className="related-category">{article.tag || "Other"}</p>
              <h3 className="related-title">
                {article.title.length > 60
                  ? article.title.slice(0, 60) + "..."
                  : article.title}
              </h3>
            </div>
          </div>
        </button>
      ))}
    </div>
  );
};

export default RelatedArticlesCard;
